<template>

  <div class="card">
    <div class="card-body">
      <highcharts
        :options="chartOptions"
        style="height: 200px;">
        </highcharts>
    </div>
    <div class="card-header">
      Descrição
    </div>
    <div class="card-body">
      <QuestionnaireDescription
        :description="meta.score_description" />
    </div>
  </div>

</template>

<script>
import QuestionnaireDescription from './QuestionnaireDescription'
import {Chart} from 'highcharts-vue'

export default {
  name: 'QuestionnairePersonalityBig5',
  components: {
    QuestionnaireDescription,
    highcharts: Chart
  },
  props: [
    'meta'
  ],
  data () {
    return {
    }
  },
  computed: {
    chartOptions () {
      return {
        chart: {
          type: 'bar'
        },
        lang: {
          noData: this.$t('No data to display')
        },
        title: {
          text: null
        },
        subtitle: {
          text: null
        },
        xAxis: {
          type: 'category'
        },
        yAxis: {
          max: this.meta.max_score,
          title: {
            text: null
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          // headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>'
        },
        series: [
          {
            name: 'Fatores',
            colorByPoint: true,
            data: [
              {
                name: 'Abertura',
                y: this.meta.openness
              },
              {
                name: 'Conscienciosidade',
                y: this.meta.conscientiousness
              },
              {
                name: 'Extroversão',
                y: this.meta.extraversion
              },
              {
                name: 'Agradabilidade',
                y: this.meta.agreeableness
              },
              {
                name: 'Estabilidade emocional',
                y: this.meta.emotional_stability
              }
            ]
          }
        ]
      }
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Questionnaire/QuestionnairePersonalityBig5.vue